import { PRODUCT_REQUISITION_TIME } from "@component/Mortgage/LeadForm/Steps/LeadForm.data";
import type { LeadFormProps, LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { faClock as fasClock, faComment as fasComment } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormSelect, FormTextArea, __ } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";

export interface StepFields extends LeadFormStepFields {
	question?: string;
}

export type StepProps = LeadFormProps;

export class LeadForm<TProps extends StepProps = StepProps> extends BasicLeadForm<StepFields, TProps> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: "Kérd részletes eredményeidet e-mailben és várd szakértőnk hívását, hogy segítsen a felmerülő kérdések tisztázásában!",
		button: "Eredmény küldése",
	};

	protected renderFields(): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				{super.renderFields()}
				<FormSelect
					name="productRequisitionTime"
					prepend={<FontAwesomeIcon icon={fasClock} />}
					options={PRODUCT_REQUISITION_TIME}
					placeholder={__("Mikor van szükséged a hitelre?")}
					disabled={submitState !== undefined}
					required
				/>
				<FormTextArea
					placeholder={__("Kérdés")}
					name="question"
					prepend={<FontAwesomeIcon icon={fasComment} />}
					disabled={submitState !== undefined}
				/>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
